import PropTypes from 'prop-types';
import { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { getDetailsMonthlyHeader } from '../services/monthlyServiceRequest';
import useToast from '../hooks/useToast';
import { getDetailsHeader } from '../services/serviceRequest';
import { statusEnum } from '../utils/dataStatus';
import { convertMonthToSpanish } from '../utils/formatUtils';

export const DetailServiceContext = createContext({
  details: null,
  loading: false,
  setLoading: () => {},
  getDetails: () => {},
  updateDetailsforAssignedStatus: () => {}
});

export const useDetailServiceRequest = () => useContext(DetailServiceContext);

export const DetailServiceRequestProvider = ({ children, montly }) => {
  const { id } = useParams();
  const [details, setDetails] = useState();
  const [loading, setLoading] = useState(true);
  const { setNewToast } = useToast();

  const getDetails = useCallback(async () => {
    try {
      const request = montly ? getDetailsMonthlyHeader : getDetailsHeader;
      const detailsResponse = await request(id);

      setDetails({ ...detailsResponse, mes: convertMonthToSpanish(detailsResponse.mes) });
      if (detailsResponse) {
        setLoading(false);
      }
    } catch (error) {
      setNewToast({
        type: 'ERROR',
        message: error.message
      });
    }

    return null;
  }, [id, montly, setNewToast]);

  const updateDetailsforAssignedStatus = useCallback(() => {
    if (details?.estadoEnum === statusEnum.asignada) {
      getDetails();
    }
  }, [details?.estadoEnum, getDetails]);

  useEffect(() => {
    if (id) getDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return (
    <DetailServiceContext.Provider
      value={{
        details,
        loading,
        setLoading,
        getDetails,
        updateDetailsforAssignedStatus
      }}
    >
      {children}
    </DetailServiceContext.Provider>
  );
};
DetailServiceRequestProvider.propTypes = {
  children: PropTypes.node.isRequired,
  montly: PropTypes.bool
};

DetailServiceRequestProvider.defaultProps = {
  montly: false
};
